import { Fragment } from "react";

type Props = {
  title?: string;
  children: React.ReactNode;
};

export function Links({ title, children }: Props) {
  return (
    <div>
      {title && (
        <Fragment>
          <div className="text-3xl font-extrabold text-zi-black">{title}</div>
          <div className="h-5" />
        </Fragment>
      )}
      <div className="ml-[-10px] grid grid-cols-[repeat(auto-fit,_346px)] justify-center gap-8">
        {children}
      </div>
    </div>
  );
}
